import { StreamType } from '@foundation-player/runtime';
import { Preset } from './preset';

export function determineStreamTypesByPreset(preset: Preset | undefined): StreamType[] {
  switch (preset) {
    case Preset.Audio:
    case Preset.DemoNative:
    case Preset.AdPlayer:
    case Preset.RTLPlusRadio:
    case Preset.RTLPlusMusicRadio:
    case Preset.RTLPlusPodcast:
    case Preset.RTLPlusMusicPodcast:
      return [StreamType.Progressive];
    case Preset.DemoDashJs:
      return [StreamType.DASH];
    default:
      return [StreamType.DASH, StreamType.HLS];
  }
}
